import * as api from "./client.js";

export type RegionPublicationRow = {
  id: number;
  regionId: string;
  regionLabel: string;
  phase: "current" | "next" | "archive";
  publicationId: number;
  publicationName: string | null;
  publicationStatus: string | null;
};

export type RegionOption = {
  id: string;
  label: string;
};

export type PublicationOption = {
  id: number;
  name: string;
  status: string;
};

export type RegionPublicationOptionsResponse = {
  regions: RegionOption[];
  publications: PublicationOption[];
};

export type CreateRegionPublicationRequest = {
  region_id: string;
  phase: "current" | "next" | "archive";
  publication_id: number;
};

type RegionPublicationListEnvelope = {
  data: RegionPublicationRow[];
};

type RegionPublicationOptionsEnvelope = {
  data: RegionPublicationOptionsResponse;
};

type RegionPublicationCreateEnvelope = {
  data: { id: number; regionId: string; phase: string; publicationId: number };
};

export const regionPublications = {
  getAll: async (): Promise<RegionPublicationRow[]> => {
    const envelope = await api.get<RegionPublicationListEnvelope>("/v1/admin/region-publications");
    return envelope.data;
  },

  getOptions: async (): Promise<RegionPublicationOptionsResponse> => {
    const envelope = await api.get<RegionPublicationOptionsEnvelope>(
      "/v1/admin/region-publications/options",
    );
    return envelope.data;
  },

  create: async (data: CreateRegionPublicationRequest): Promise<void> => {
    await api.post<RegionPublicationCreateEnvelope>("/v1/admin/region-publications", data);
  },

  delete: async (id: number): Promise<void> => {
    await api.del(`/v1/admin/region-publications/${id}`);
  },
};
